import { render, staticRenderFns } from "./SubjectSelectComponent.vue?vue&type=template&id=58904b75"
import script from "./SubjectSelectComponent.vue?vue&type=script&lang=js"
export * from "./SubjectSelectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports